<template>
    <div
        :class="[
            'tw:bg-white tw:rounded-xl tw:shadow-sm tw:flex tw:flex-col tw:gap-2 tw:border tw:border-gray-200 tw:transition-all tw:duration-150',
            customClasses
        ]"
        :style="customStyles"
    >
        <div
            v-if="title"
            :class="[bgColor + ' tw:rounded-t-xl tw:flex tw:items-center tw:gap-2 tw:py-2 tw:px-4', titleClasses]"
        >
            <h3
                :class="['tw:text-base tw:font-semibold tw:tracking-wide tw:m-0 tw:flex tw:items-center tw:gap-2', titleColor && titleColor.startsWith('tw:') ? titleColor : '']"
                :style="titleColor && !titleColor.startsWith('tw:') ? `color: ${titleColor}` : ''"
            >
                <i v-if="icon" :class="[icon, 'tw:text-xl tw:align-middle tw:translate-y-px']"></i>
                {{ title }}
            </h3>
        </div>

        <div :class="PADDING_MAP[padding] ?? 'tw:p-6'">
            <slot></slot>
        </div>

        <div v-if="$slots.footer" class="tw:mt-2">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script setup>
    const PADDING_MAP = { 0: 'tw:p-0', 1: 'tw:p-1', 2: 'tw:p-2', 3: 'tw:p-3', 4: 'tw:p-4' };

    defineProps({
        bgColor: { type: String, default: 'tw:bg-white' },
        customClasses: { type: String, default: '' },
        customStyles: { type: String, default: '' },
        title: { type: String, default: '' },
        titleColor: { type: String, default: '' },
        titleClasses: { type: String, default: '' },
        icon: { type: String, default: '' },
        padding: { type: [String, Number], default: '6' }
    });
</script>
